import script from "./UserLink.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserLink.vue?vue&type=script&lang=ts&setup=true"

import "./UserLink.vue?vue&type=style&index=0&id=1084f5b0&scoped=true&lang=css"

import exportComponent from "/home/deployment/actions-runner/_work/pwscorecards-vue/pwscorecards-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1084f5b0"]])

export default __exports__